import React, { useState } from "react";
import { FooterProps } from "./Footer.types";
import { MapTo } from "@adobe/aem-react-editable-components";
import { FooterContainer } from "./Footer.styles";
import { useIsMobile } from "src/utils/js/useIsMobile";

import {
	RangoFooterBrandDescription,
	RangoFooterContainer,
	RangoFooterSocialMedia,
} from "@rango/core";
import FooterMobile from "./FooterViews/FooterMobile";
import FooterDesktop from "./FooterViews/FooterDesktop";

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
	const { gridFooter, copyright, socialMedia } = props;

	const { isMobile } = useIsMobile();
	const [responsive, setResponsive] = useState(isMobile);

	return (
		<FooterContainer>
			<RangoFooterContainer
				showBase={false}
				onResponsive={(isMobile) => setResponsive(isMobile)}
			>
				<div
					className="rango-row"
					slot="bottom"
					style={{ alignItems: "center" }}
				>
					<div
						className="rango-col-1 rango-col-md-7 rango-col-lg-7 rango-col-xl-8"
						style={{
							gridRow: responsive ? "2" : "",
							paddingTop: responsive ? "var(--spacing-4x)" : "",
						}}
					>
						<RangoFooterBrandDescription
							firstText={copyright.firstText}
							secondText={copyright.secondText}
						/>
					</div>

					<div
						className="rango-col-1 rango-col-md-5 rango-col-lg-5 rango-col-xl-4"
						style={{ justifySelf: responsive ? "" : "flex-end" }}
					>
						<RangoFooterSocialMedia
							title={socialMedia.title}
							facebookProps={
								socialMedia.urlFacebook
									? {
										href: socialMedia.urlFacebook,
										title: 'Link Facebook',
										destination: socialMedia.urlFacebook,
										element_parent: 'footer',
										element_type: "link"
									}
									: undefined
							}
							instagramProps={
								socialMedia.urlInstagram
									? {
										href: socialMedia.urlInstagram,
										title: 'Link Instagram',
										destination: socialMedia.urlInstagram,
										element_parent: 'footer',
										element_type: "link"
									}
									: undefined
							}
							linkedInProps={
								socialMedia.urlLinkedIn
									? {
										href: socialMedia.urlLinkedIn,
										title: 'Link linkedIn',
										destination: socialMedia.urlLinkedIn,
										element_parent: 'footer',
										element_type: "link"
									}
									: undefined
							}
							youtubeProps={
								socialMedia.urlYoutube
									? {
										href: socialMedia.urlYoutube,
										title: 'Link Youtube',
										destination: socialMedia.urlYoutube,
										element_parent: 'footer',
										element_type: "link"
									}
									: undefined
							}
							tiktokProps={
								socialMedia.urlTiktok
									? {
										href: socialMedia.urlTiktok,
										title: 'Link Tiktok',
										destination: socialMedia.urlTiktok,
										element_parent: 'footer',
										element_type: "link"
									}
									: undefined
							}
						/>
					</div>
				</div>

				<div slot="navigation">
					{responsive ? (
						<div className="rango-row">
							<FooterMobile gridFooter={gridFooter} />
						</div>
					) : (
						<FooterDesktop gridFooter={gridFooter} />
					)}
				</div>
			</RangoFooterContainer>
		</FooterContainer>
	);
};

const FooterConfig = {
	emptyLabel: "Footer",
	isEmpty: function (props: FooterProps) {
		return (
			!props || !props.gridFooter || props.gridFooter.listColumns.length === 0
		);
	},
};

MapTo<FooterProps>("alelo/components/content/v1/footer")(Footer, FooterConfig);

export default Footer;
